module.exports = __webpack_public_path__ + "img/layout_vertical_right.409e130a.svg";